// createMuiThemeWithSsrMatchMedia.ts
import { createTheme } from '@mui/material/styles';
import createCache from '@emotion/cache';

export function createBaseTheme(options = {}) {
    return createTheme({
        palette: {
            mode: 'light'
        },
        typography: {
            fontFamily: 'BCAASans, sans-serif'
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
                desktop: 1300 // custom breakpoint for 1299+ px logic
            }
        },
        components: {
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: 'red'
                    }
                }
            }
        },
        ...options
    });
}

export function createSsrTheme(userAgent) {
    const isMobile = userAgent?.toLowerCase().includes('mobile') ?? false;

    return createBaseTheme({
        components: {
            MuiUseMediaQuery: {
                defaultProps: {
                    ssrMatchMedia: query => ({
                        matches: isMobile ? query.includes('max-width') : query.includes('min-width'),
                        media: query
                    })
                }
            }
        }
    });
}

export const clientTheme = createBaseTheme();

export function createEmotionCache() {
    return createCache({
        key: 'css',
        prepend: true
    });
}
